import type { TranslationDict } from '../en';

const gu: TranslationDict = {
  'header.buy': 'ખરીદો',
  'header.sell': 'વેચો',
  'spend.label': 'તમે ખર્ચ કરો છો',
  'spend.placeholderFiat': '250',
  'spend.placeholderCrypto': '0.01',
  'receive.label': 'તમને મળશે',
  'payment.label': 'ચુકવણી પદ્ધતિ',
  'payment.select': 'પસંદ કરો',
  'provider.label': 'By',
  'provider.select': 'Select',
  'provider.unavailable': 'Unavailable',
  'provider.unavailablePayment': 'Payment method not supported',
  'provider.unavailableCountry': 'Region not supported',
  'provider.unavailableCurrency': 'Currency not supported',
  'provider.unavailableNetwork': 'Network not supported',
  'payment.noneAvailable': 'આ જોડ માટે કોઈ ચુકવણી પદ્ધતિ ઉપલબ્ધ નથી',
  'wallet.label': 'પ્રાપ્ત કરતું વૉલેટ સરનામું',
  'wallet.placeholderBuy': 'તમારું પ્રાપ્ત કરતું સરનામું દાખલ કરો',
  'wallet.placeholderSell': 'તમારું મોકલવાનું સરનામું દાખલ કરો',
  'wallet.validating': 'સરનામું ચકાસી રહ્યા છીએ...',
  'wallet.invalid': 'માન્ય વૉલેટ સરનામું દાખલ કરો',
  'wallet.invalidServer': 'અમાન્ય વૉલેટ સરનામું',
  'cta.buy': '{crypto} ખરીદો',
  'cta.sell': '{crypto} વેચો',
  'cta.gettingPrice': 'શ્રેષ્ઠ ભાવ મેળવી રહ્યા છીએ...',
  'cta.processing': 'પ્રક્રિયા ચાલી રહી છે...',
  'footer.poweredBy': 'દ્વારા સંચાલિત ',
  'footer.brand': 'NowRamp',
  'rate.title': 'દર વિગત',
  'rate.close': 'બંધ કરો',
  'rate.updatesIn': 'દર 00:{seconds} માં અપડેટ થશે',
  'rate.noQuote': 'કોઈ અવતરણ ઉપલબ્ધ નથી',
  'rate.exchangeRate': 'વિનિમય દર',
  'rate.processingFee': 'પ્રક્રિયા ફી',
  'rate.networkFee': 'નેટવર્ક ફી',
  'rate.provider': 'સેવા પ્રદાતા',
  'toast.orderCreated': 'ઓર્ડર બનાવ્યો',
  'toast.redirecting': 'ચેકઆઉટ પર રિડાયરેક્ટ થઈ રહ્યા છીએ...',
  'toast.orderFailed': 'ઓર્ડર નિષ્ફળ',
  'toast.couldNotCreate': 'ઓર્ડર બનાવી શકાયો નહીં',
  'toast.quoteError': 'અવતરણ ભૂલ',
  'toast.noProviders': 'કોઈ સેવા પ્રદાતા નહીં',
  'toast.somethingWrong': 'કંઈક ખોટું થયું',
  'error.amountZero': 'રકમ 0 કરતાં વધુ હોવી જોઈએ',
  'error.minAmountFiat': 'ન્યૂનતમ રકમ {min} {currency} છે',
  'error.minAmountCrypto': 'ન્યૂનતમ રકમ {min} {currency} છે',
  'error.noProviders': 'આ સંયોજન માટે કોઈ સેવા પ્રદાતા ઉપલબ્ધ નથી',
  'error.currencyUnavailableBuy': 'આ ચલણ ખરીદ ઓર્ડર માટે ઉપલબ્ધ નથી',
  'error.currencyUnavailableSell': 'આ ચલણ વેચાણ ઓર્ડર માટે ઉપલબ્ધ નથી',
  'parity.info': 'તમને {receiveAmount} {crypto} માટે ચાર્જ કરવામાં આવશે, બાકીની {spendAmount} {fiat} સુધીની રકમ તમારા {partner} એકાઉન્ટમાં જમા થશે',
  'redirect.secureBadge': 'સુરક્ષિત ચુકવણી',
  'redirect.title': 'ચુકવણી ચાલુ રાખો',
  'redirect.description': 'તમારી ચુકવણી પૂર્ણ કરવા માટે તમને {gateway} પર રિડાયરેક્ટ કરવામાં આવશે.',
  'redirect.countdown': '{seconds} માં રિડાયરેક્ટ થઈ રહ્યા છીએ...',
  'redirect.openTab': 'નવી ટૅબમાં ACH ખોલો',
  'redirect.cancel': 'રદ કરો',
  'checkout.noOrder': 'કોઈ ઓર્ડર મળ્યો નહીં',
  'checkout.goBack': 'પાછા જાઓ',
  'checkout.expired': 'ચેકઆઉટ સમાપ્ત',
  'checkout.expiredDesc': 'સત્ર સમાપ્ત થઈ ગયું છે. કૃપા કરીને ફરી પ્રયાસ કરો.',
  'checkout.startOver': 'ફરીથી શરૂ કરો',
  'checkout.cancel': 'રદ કરો',
  'checkout.loading': 'ચેકઆઉટ લોડ થઈ રહ્યું છે...',
  'checkout.iframeTitle': 'સેવા પ્રદાતા ચેકઆઉટ',
  'checkout.widgetTitle': 'ચુકવણી ચેકઆઉટ',
  'checkout.unknownMethod': 'અજ્ઞાત ચેકઆઉટ પદ્ધતિ',
  'processing.default': 'તમારો ઓર્ડર પ્રક્રિયા હેઠળ છે...',
  'processing.pending': 'ચુકવણી પુષ્ટિની રાહ જોઈ રહ્યા છીએ...',
  'processing.active': 'તમારો વ્યવહાર પ્રક્રિયા હેઠળ છે...',
  'processing.generic': 'પ્રક્રિયા ચાલી રહી છે...',
  'processing.checkingStatus': 'સ્થિતિ તપાસી રહ્યા છીએ...',
  'processing.orderId': 'ઓર્ડર ID',
  'processing.provider': 'સેવા પ્રદાતા',
  'processing.amount': 'રકમ',
  'processing.receiving': 'મળી રહ્યું છે',
  'processing.network': 'નેટવર્ક',
  'processing.toAddress': 'સ્થળ સરનામું',
  'processing.usuallyMinutes': 'આ સામાન્ય રીતે થોડી મિનિટો લે છે.',
  'processing.safeToClose': 'તમે આ પૃષ્ઠ સુરક્ષિત રીતે બંધ કરી શકો છો - પૂર્ણ થાય ત્યારે અમે તમને ઈમેઈલ મોકલીશું.',
  'complete.buyTitle': 'ખરીદી પૂર્ણ!',
  'complete.sellTitle': 'વેચાણ પૂર્ણ!',
  'complete.buyDesc': 'તમારું {crypto} તમારા વૉલેટમાં મોકલ્યું છે.',
  'complete.sellDesc': 'તમારી {fiat} ચુકવણી પ્રક્રિया ચાલી રહી છે.',
  'complete.amountBuy': 'પ્રાપ્ત રકમ',
  'complete.amountSell': 'વેચેલી રકમ',
  'complete.paidBuy': 'ચૂકવેલ રકમ',
  'complete.paidSell': 'ચુકવણી રકમ',
  'complete.network': 'નેટવર્ક',
  'complete.wallet': 'વૉલેટ',
  'complete.transaction': 'વ્યવહાર',
  'complete.provider': 'સેવા પ્રદાતા',
  'complete.orderId': 'ઓર્ડર ID',
  'complete.completed': 'પૂર્ણ',
  'complete.viewExplorer': 'એક્સ્પ્લોરરમાં જુઓ',
  'complete.done': 'થઈ ગયું',
  'errorStep.failed': 'ચુકવણી નિષ્ફળ',
  'errorStep.cancelled': 'ઓર્ડર રદ',
  'errorStep.expired': 'ઓર્ડર સમાપ્ત',
  'errorStep.refunded': 'ઓર્ડર પરત',
  'errorStep.unknown': 'કંઈક ખોટું થયું',
  'errorStep.failedBuy': 'તમારી ચુકવણી પ્રક્રિયા થઈ શકી નહીં. કૃપા કરીને ફરી પ્રયાસ કરો અથવા અલગ ચુકવણી પદ્ધતિ વાપરો.',
  'errorStep.failedSell': 'તમારું વેચાણ પ્રક્રિયા થઈ શક્યું નહીં. કૃપા કરીને ફરી પ્રયાસ કરો.',
  'errorStep.cancelledBuy': 'તમારો ઓર્ડર રદ કરવામાં આવ્યો. કોઈ ચુકવણી પ્રક્રિયા થઈ નહીં.',
  'errorStep.cancelledSell': 'તમારું વેચાણ રદ કરવામાં આવ્યું. કોઈ ક્રિપ્ટો ટ્રાન્સફર થઈ નહીં.',
  'errorStep.expiredBuy': 'તમારો ઓર્ડર સમાપ્ત થઈ ગયો છે. કૃપા કરીને નવી ખરીદી શરૂ કરો.',
  'errorStep.expiredSell': 'તમારો ઓર્ડર સમાપ્ત થઈ ગયો છે. કૃપા કરીને નવું વેચાણ શરૂ કરો.',
  'errorStep.refundedBuy': 'તમારી ચુકવણી પરત કરવામાં આવી છે. 5-10 કામકાજના દિવસોમાં રકમ તમારા ખાતામાં દેખાશે.',
  'errorStep.refundedSell': 'તમારું ક્રિપ્ટો પરત કરવામાં આવ્યું છે. ટૂંક સમયમાં રકમ તમારા વૉલેટમાં દેખાશે.',
  'errorStep.genericDesc': 'એક અણધારી ભૂલ આવી. કૃપા કરીને ફરી પ્રયાસ કરો.',
  'errorStep.orderId': 'ઓર્ડર ID',
  'errorStep.tryAgain': 'ફરી પ્રયાસ કરો',
  'errorStep.startOver': 'ફરીથી શરૂ કરો',
  'errorStep.return': 'પાછા જાઓ',
  'errorStep.needHelp': 'મદદ જોઈએ છે? સંપર્ક કરો ',
  'errorStep.reference': 'સંદર્ભ: {orderId}',
  'confirm.buyTitle': 'ખરીદીની પુષ્ટિ કરો',
  'confirm.sellTitle': 'વેચાણની પુષ્ટિ કરો',
  'confirm.loading': 'લોડ થઈ રહ્યું છે...',
  'confirm.provider': 'સેવા પ્રદાતા',
  'confirm.youPay': 'તમે ચૂકવો છો',
  'confirm.youSell': 'તમે વેચો છો',
  'confirm.youReceive': 'તમને મળશે',
  'confirm.wallet': 'વૉલેટ',
  'confirm.network': 'નેટવર્ક',
  'confirm.refundAddress': 'પરત સરનામું',
  'confirm.parityNote': 'સેવા પ્રદાતા દ્વારા ચાર્જ કરેલ રકમ અલગ હોઈ શકે. બાકીની {amount} {crypto} સુધીની રકમ તમારા {partner} ખાતામાં જમા થશે.',
  'confirm.processing': 'પ્રક્રિયા ચાલી રહી છે...',
  'confirm.confirmPay': 'પુષ્ટિ કરો અને ચૂકવો',
  'confirm.confirmSell': 'પુષ્ટિ કરો અને વેચો',
  'confirm.payout': '{currency} ચુકવણી',
  'modal.selectFiat': 'ફિએટ ચલણ પસંદ કરો',
  'modal.selectCrypto': 'ક્રિપ્ટો ચલણ પસંદ કરો',
  'modal.choosePayment': 'ચુકવણી પદ્ધતિ પસંદ કરો',
  'modal.selectCountry': 'તમારો દેશ પસંદ કરો',
  'modal.selectLanguage': 'Select language',
  'modal.popular': 'લોકપ્રિય',
  'modal.recommended': 'ભલામણ કરેલ',
  'modal.noCurrencies': 'કોઈ ચલણ મળ્યું નહીં',
  'modal.noPaymentMethods': 'કોઈ ચુકવણી પદ્ધતિ મળી નહીં',
  'modal.noCountries': 'કોઈ દેશ મળ્યો નહીં',
  'modal.noLanguages': 'No languages found',
  'settings.location': 'સ્થાન',
  'settings.darkMode': 'ડાર્ક મોડ',
  'settings.privacy': 'ગોપનીયતા નીતિ',
  'settings.terms': 'ઉપયોગની શરતો',
  'settings.language': 'ભાષા',

  // ─── Additional ───
  'modal.chooseRamp': 'Ramp પસંદ કરો',
  'modal.bestPrice': 'શ્રેષ્ઠ ભાવ',
  'modal.noQuotes': 'આ વિનંતી માટે કોઈ અવતરણ ઉપલબ્ધ નથી',
  'modal.noProvidersFound': 'કોઈ સેવા પ્રદાતા મળ્યા નહીં',
  'payment.unavailableFor': '{currency} માટે કોઈ ચુકવણી પદ્ધતિ ઉપલબ્ધ નથી',
  'skeleton.poweredBy': 'NowRamp દ્વારા સંચાલિત',
  'error.createOrderFailed': 'ઓર્ડર બનાવવામાં નિષ્ફળ',
  'errorStep.returnToMerchant': 'વેપારી પાસે પાછા જાઓ',
  'confirm.cryptoOnNetwork': '{crypto} {network} પર',
  'payment.name.card': 'કાર્ડ',
  'payment.name.bankTransfer': 'બેંક ટ્રાન્સફર',
  'payment.name.ach': 'ACH',
  'rate.updatesInLabel': 'Rate updates in',
  'rate.networkFeeIncl': 'Network fee incl.',
  'rate.rateTooltip': 'As the market is highly volatile, we can fix the exchange rate for no longer than 30 seconds.',
  'rate.networkFeeTooltip': 'Includes a fee charged by blockchain to execute the transaction.',
  'rate.feeIncluded': '{percentage}% incl.',
  'receive.fetchingRate': 'Fetching best rate...',
  'redirect.tabHelper': 'If the new tab has not opened, click the button above.',
};

export default gu;
